var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Close_x_icon",
    "data-name": "Close x icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2058",
    "data-name": "Ellipse 2058",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#ecebf2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91842",
    "data-name": "Group 91842",
    transform: "translate(9.223 8.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12025",
    "data-name": "Rectangle 12025",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(0 1.415) rotate(-45)",
    fill: "#7e7e9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12026",
    "data-name": "Rectangle 12026",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(1.414 9.9) rotate(-135)",
    fill: "#7e7e9c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9a98029723748803c6b38a548a0d51bf.svg";
export { ForwardRef as ReactComponent };